import ChatBubbleOutlinedIcon from '@mui/icons-material/ChatBubbleOutlined';
import InfoIcon from '@mui/icons-material/Info';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { isImpersonating } from '@pn/core/utils/impersonate';
import { useFreshdesk } from '@pn/services/support/useFreshdesk';
import React from 'react';

type Props = {
  appName: 'maps' | 'intel';
  collapsed?: boolean;
};

export const HelpButton = ({ appName, collapsed = false }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const { handleOpenContactUs } = useFreshdesk(appName);

  return (
    <>
      {collapsed ? (
        <Tooltip title="Help" arrow placement={'right'}>
          <IconButton
            color="inherit"
            onClick={(event) => setAnchorEl(event.currentTarget)}
          >
            <InfoIcon sx={{ color: 'text.secondary' }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          color="inherit"
          variant="contained"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          endIcon={<InfoIcon sx={{ color: 'text.secondary' }} />}
          sx={{ px: 3, textTransform: 'none' }}
        >
          Help
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          component="a"
          href={`https://help-${appName}.stackdx.com`}
          target="_blank"
          onClick={() => setAnchorEl(null)}
        >
          <ListItemIcon>
            <LibraryBooksOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Knowledge Base</ListItemText>
        </MenuItem>
        <MenuItem
          disabled={isImpersonating()}
          onClick={() => {
            handleOpenContactUs();
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <ChatBubbleOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Contact Us</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
